@if (isLoading) {
  <scattre-loading></scattre-loading>
}
<workspace-layout></workspace-layout>
